import { AuthErrorCode, CommonErrorCode } from '@pulsify/shared/errors'
import {
  PASSWORD_MAX_LENGTH,
  PASSWORD_MIN_LENGTH,
  validatePasswordPolicy,
} from '@pulsify/shared/password'
import * as m from '~/paraglide/messages'

function passwordErrorMessage(code: string): string {
  switch (code) {
    case AuthErrorCode.PasswordTooShort:
      return m.passwordTooShortError({ minLength: PASSWORD_MIN_LENGTH })
    case AuthErrorCode.PasswordTooLong:
      return m.passwordTooLongError({ maxLength: PASSWORD_MAX_LENGTH })
    case AuthErrorCode.WeakPassword:
      return m.weakPasswordError()
    case CommonErrorCode.ValidationFailed:
      return m.passwordRequired()
    default:
      return m.weakPasswordError()
  }
}

/**
 * Run the shared policy and return a localized error message on failure,
 * or `null` on success. Use as the single source of truth for password
 * messages in zod schemas (via `superRefine`) and form-onSubmit handlers.
 */
export function validatePasswordForForm(
  password: string,
  userInputs: readonly (string | null | undefined)[] = [],
): string | null {
  const policy = validatePasswordPolicy(password, userInputs)
  return policy.success ? null : passwordErrorMessage(policy.code)
}
